let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("9gd3o"), load("8N5TC"), load("63hq6")]).then(() => parcelRequire('el8fJ'));